export var NavigationBarButtonStyle;
(function (NavigationBarButtonStyle) {
    NavigationBarButtonStyle["LIGHT"] = "#FFFFFF";
    NavigationBarButtonStyle["DARK"] = "#000000";
})(NavigationBarButtonStyle || (NavigationBarButtonStyle = {}));
export var NavigationBarColor;
(function (NavigationBarColor) {
    NavigationBarColor["WHITE"] = "#FFFFFF";
    NavigationBarColor["BLACK"] = "#000000";
    NavigationBarColor["TRANSPARENT"] = "transparent";
})(NavigationBarColor || (NavigationBarColor = {}));
//# sourceMappingURL=definitions.js.map